import { filters } from '@content/results';

// ---------------------------------------------------------

export default {
  additional: { filters: [filters.additional] },
  bedAndBath: { filters: [filters.bedAndBath] },
  groupOfFilters: {
    filters: [filters.statusAndType, filters.price, filters.bedAndBath, filters.additional]
  },
  price: { filters: [filters.price] },
  props: { filters: [filters.statusAndType] },
  statusAndType: { filters: [filters.statusAndType] }
};
